import TableThingyView from '../view/table_view';
import {connect} from "react-redux";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { requestDataFromAPI, publishNews} from '../thunk/table_tunc';
import {TableThingyActions} from '../actions/table_actions';
import { News } from '../typing/table_typing';
interface OwnProps {
    id:string;
}

function mapStateToProps(state:RootState, ownProps:OwnProps){  
    const myprops=
    {
        data:state.newslist.model,
        view:state.newslist.view,
    }
    return myprops;
}

function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
    return {
        onLoadRequested:()=>{ 
            dispatch(requestDataFromAPI() as any);
        },
        onValueChange:(what:string, uuid:string)=>{
            dispatch(TableThingyActions.toogleEntry({what, uuid}))
        },
        onPublishNews:(newsfeed:News[]) => {
            dispatch(publishNews(newsfeed) as any)
        }
    }
}


const LicenseListContainer=connect(mapStateToProps, bindDispatchToActions)(TableThingyView);
export default LicenseListContainer;